// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vs-swatch-color{border:1px solid rgba(0,0,0,.07)}.vs-swatch-color.transparent{background-size:10px 10px;background-repeat:round;background-image:repeating-conic-gradient(#fff 0deg,#fff 90deg,#ccc 0deg,#ccc 180deg);background-image:repeating-conic-gradient(#fff 0deg 90deg,#ccc 0deg 180deg)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
